import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBuilding, FaChevronRight } from "react-icons/fa";
import { useAuthStore } from "../../services/useAuthStore";
import "./WorkspaceSelector.css";

const WorkspaceSelector = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  const user = useAuthStore((s) => s.user);
  const workspaces = useAuthStore((s) => s.workspaces);
  const switchWorkspace = useAuthStore((s) => s.switchWorkspace);

  const handleSelectWorkspace = async (workspaceId) => {
    setIsLoading(true);
    setSelectedId(workspaceId);
    setError("");

    try {
      await switchWorkspace(workspaceId);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Falha ao selecionar workspace");
      setSelectedId(null);
    } finally {
      setIsLoading(false);
    }
  };

  const getRoleBadgeClass = (role) => {
    const roleMap = {
      admin: "role-admin",
      manager: "role-manager",
      operator: "role-operator",
      finance: "role-finance",
    };
    return roleMap[role?.toLowerCase()] || "role-default";
  };

  const getRoleLabel = (role) => {
    const roleLabels = {
      admin: "Administrador",
      manager: "Gerente",
      operator: "Operador",
      finance: "Financeiro",
    };
    return roleLabels[role?.toLowerCase()] || role;
  };

  return (
    <div className="workspace-selector-page">
      <div className="workspace-selector-container">
        <div className="workspace-selector-header">
          <img
            src="/logoFastTeamGreen.png"
            alt="FastTeam Logo"
            className="workspace-selector-logo"
          />
          <h1 className="workspace-selector-title">Selecione um Workspace</h1>
          {user && (
            <p className="workspace-selector-subtitle">
              Ola, <strong>{user.name}</strong>! Escolha o workspace que deseja acessar.
            </p>
          )}
        </div>

        {error && (
          <div className="workspace-selector-error">
            {error}
          </div>
        )}

        <div className="workspace-list">
          {workspaces.map((ws) => (
            <button
              key={ws.id}
              onClick={() => handleSelectWorkspace(ws.id)}
              disabled={isLoading}
              className={`workspace-card ${selectedId === ws.id ? "loading" : ""}`}
            >
              <div className="workspace-card-icon">
                <FaBuilding />
              </div>
              <div className="workspace-card-content">
                <h3 className="workspace-card-name">{ws.name}</h3>
                <span className={`workspace-card-role ${getRoleBadgeClass(ws.role)}`}>
                  {getRoleLabel(ws.role)}
                </span>
              </div>
              <div className="workspace-card-arrow">
                {selectedId === ws.id && isLoading ? (
                  <div className="workspace-card-spinner"></div>
                ) : (
                  <FaChevronRight />
                )}
              </div>
            </button>
          ))}
        </div>

        <div className="workspace-selector-footer">
          <p>Precisa de ajuda? Entre em contato com o suporte.</p>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceSelector;
